<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>

      <v-flex xs12>
        <v-card color="grey lighten-3">
          <v-card-text>
            <p style="color: #6b6b6b;">Текущий баланс:</p>
            <p class="text-xs-center display-2">460 руб.</p>
          </v-card-text>
          <v-card-actions>
            <v-btn color="secondary" dark>Пополнить</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="secondary" dark @click="viewDetails">Детализация</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      
      <v-flex xs12 v-if="showDetails">
        <v-data-table
          :headers="headers"
          :items="items"
          rows-per-page-text="Элементов на страницу"
          :rows-per-page-items="rowsPerPage"
          no-data-text="Нет доступных данных"
          :loading="loading"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.date }}</td>
            <td>{{ props.item.description }}</td>
            <td>
              <b :class="{'green--text':props.item.income, 'red--text':!props.item.income}">
                {{(props.item.income)?'+':'-'}}{{ props.item.sum }}
              </b>
            </td>
            <td class="text-xs-center">{{ props.item.total }}</td>
          </template>
          <template slot="pageText" slot-scope="props">
            Lignes {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
          <template slot="pageText" slot-scope="{ pageStart, pageStop }">
            Записи с {{ pageStart }} по {{ pageStop }}
          </template>
        </v-data-table>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name : 'Bill',
    
    data() {
      return {
        rowsPerPage: [20, 50, { text: 'Все', value: -1 }],
        headers: [
          { text: 'Дата', align: 'left', sortable: false, width: 100 },
          { text: 'Комментарий',  sortable: false },
          { text: 'Сумма',  sortable: false },
          { text: 'Остаток на счету', align: 'center', sortable: false },
        ],
        items: [],
        loading: false,
        showDetails: false
      }
    },
    
    methods : {
      viewDetails(){
        this.loading = true
        this.showDetails = true
        this.items = []
        
        setTimeout( () => {
          this.items = [
            { date: '02.05.2018', sum: 408, description:'Списание абонентской платы', income: false, total: '460' },
            { date: '01.05.2018', sum: 500, description:'Пополнение личного счета', income: true, total: '868' },
            { date: '02.04.2018', sum: 408, description:'Списание абонентской платы', income: false, total: '368' },
            { date: '01.04.2018', sum: 500, description:'Пополнение личного счета', income: true, total: '776' },
            { date: '02.03.2018', sum: 408, description:'Списание абонентской платы', income: false, total: '276' },
            { date: '01.03.2018', sum: 500, description:'Пополнение личного счета', income: true, total: '684' },
            { date: '02.02.2018', sum: 408, description:'Списание абонентской платы', income: false, total: '184' },
            { date: '01.02.2018', sum: 500, description:'Пополнение личного счета', income: true, total: '592' },
            { date: '02.02.2018', sum: 408, description:'Списание абонентской платы', income: false, total: '92' },
            { date: '01.01.2018', sum: 500, description:'Пополнение личного счета', income: true, total: '500' }
          ]
          this.loading = false
        }, 2000)
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/apps/account/components/Account/Bill.vue